<div class="measurement-sidebar">
  <!-- Contrast/Brightness toggle -->
  <button
    class="tool-btn"
    [class.active]="isContrastMode"
    (click)="onToolClick('contrast')"
    [title]="'modelViewer.contrastMode' | translate"
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 2a10 10 0 0 1 0 20V2z" fill="currentColor"/>
    </svg>
  </button>

  <div class="sidebar-divider"></div>

  <!-- Zoom In -->
  <button
    class="tool-btn"
    [class.active]="activeTool === 'zoom-in'"
    (click)="onToolClick('zoom-in')"
    [title]="'modelViewer.zoomIn' | translate"
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
      <line x1="16.5" y1="16.5" x2="21" y2="21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <line x1="8" y1="11" x2="14" y2="11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <line x1="11" y1="8" x2="11" y2="14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </button>

  <!-- Pan/Move -->
  <button
    class="tool-btn"
    [class.active]="activeTool === 'pan'"
    (click)="onToolClick('pan')"
    [title]="'modelViewer.pan' | translate"
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 9l-3 3 3 3M9 5l3-3 3 3M19 9l3 3-3 3M9 19l3 3 3-3M12 2v20M2 12h20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <!-- Distance Measurement -->
  <button
    class="tool-btn"
    [class.active]="activeTool === 'measure-distance'"
    (click)="onToolClick('measure-distance')"
    [title]="'modelViewer.measureLength' | translate"
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <line x1="3" y1="8" x2="3" y2="16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <line x1="21" y1="8" x2="21" y2="16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="3" cy="12" r="1.5" fill="currentColor"/>
      <circle cx="21" cy="12" r="1.5" fill="currentColor"/>
    </svg>
  </button>

  <!-- Angle Measurement -->
  <button
    class="tool-btn"
    [class.active]="activeTool === 'measure-angle'"
    (click)="onToolClick('measure-angle')"
    [title]="'modelViewer.measureAngle' | translate"
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 20L12 4L20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7 14 Q12 10 17 14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" fill="none"/>
    </svg>
  </button>

  <!-- Area Measurement -->
  <button
    class="tool-btn"
    [class.active]="activeTool === 'area'"
    (click)="onToolClick('area')"
    [title]="'modelViewer.measureArea' | translate"
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 12 L8 5 L16 5 L20 12 L16 19 L8 19 Z" stroke="currentColor" stroke-width="1.5" stroke-dasharray="3 2" stroke-linejoin="round"/>
      <circle cx="4" cy="12" r="1.5" fill="currentColor"/>
      <circle cx="8" cy="5" r="1.5" fill="currentColor"/>
      <circle cx="16" cy="5" r="1.5" fill="currentColor"/>
      <circle cx="20" cy="12" r="1.5" fill="currentColor"/>
    </svg>
  </button>

  <!-- Area in-progress: nokta sayacı + Kapat butonu -->
  <ng-container *ngIf="activeTool === 'area' && areaPointCount > 0">
    <div class="area-point-count">{{ areaPointCount }}</div>
    <button
      *ngIf="isAreaInProgress"
      class="tool-btn finalize-btn"
      (click)="onFinalizeArea()"
      [title]="'modelViewer.finalizePolygon' | translate"
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <polyline points="20 6 9 17 4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </ng-container>

  <div class="sidebar-divider"></div>

  <!-- Reset View -->
  <button
    class="tool-btn"
    (click)="onToolClick('reset')"
    [title]="'modelViewer.resetView' | translate"
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3 3v5h5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <!-- Texture Toggle -->
  <button
    class="tool-btn"
    [class.active]="!isTextureMode"
    (click)="onToolClick('texture')"
    [title]="'modelViewer.textureMode' | translate"
  >
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
      <path d="M12 2a10 10 0 0 1 0 20V2z" fill="currentColor" opacity="0.4"/>
      <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.2"/>
    </svg>
  </button>
</div>
